module.exports = __webpack_public_path__ + "img/7diamonds.028923d6.jpg";